/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Square_Brackets_DescInputs */

const en_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removes content within square brackets`)
};

const fr_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprime le contenu entre crochets`)
};

const de_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernt den Inhalt innerhalb eckiger Klammern.`)
};

const it_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuove il contenuto tra parentesi quadre`)
};

const ru_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаляет содержимое внутри квадратных скобок.`)
};

const es_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina el contenido entre corchetes`)
};

const zh_cn2_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除方括号内的内容`)
};

const ja_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角括弧内のコンテンツを削除します`)
};

const hi_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्गाकार कोष्ठकों के भीतर की सामग्री को हटाता है`)
};

const pt_pt2_remove_square_brackets_desc = /** @type {(inputs: Remove_Square_Brackets_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove o conteúdo entre colchetes`)
};

/**
* | output |
* | --- |
* | "Removes content within square brackets" |
*
* @param {Remove_Square_Brackets_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_square_brackets_desc = /** @type {((inputs?: Remove_Square_Brackets_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Square_Brackets_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_square_brackets_desc(inputs)
	if (locale === "de") return de_remove_square_brackets_desc(inputs)
	if (locale === "it") return it_remove_square_brackets_desc(inputs)
	if (locale === "ru") return ru_remove_square_brackets_desc(inputs)
	if (locale === "es") return es_remove_square_brackets_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_square_brackets_desc(inputs)
	if (locale === "ja") return ja_remove_square_brackets_desc(inputs)
	if (locale === "hi") return hi_remove_square_brackets_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_square_brackets_desc(inputs)
	return en_remove_square_brackets_desc(inputs)
});